import presenterListPopoverTemplate from './presenter-list-popover.html';

/* @ngInject */
export const templates = function ($templateCache) {
	$templateCache.put('presenter-list/presenter-list-popover.html', presenterListPopoverTemplate);
};
